import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LOGOS } from "../data/brands";

// Header used across sub-brand sites. Logo left, nav right, glass background.
export default function Header({ brandKey = "group", brandName = "De Jure Group" }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Approach", href: "#approach" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-dejure-silver/25 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
          : "bg-white/40 backdrop-blur-md py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <Link to={`/${brandKey === "group" ? "" : brandKey}`} data-testid="header-logo-link" className="flex items-center">
          <img src={LOGOS[brandKey]} alt={brandName} className="h-11 md:h-14 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <Link
            to="/"
            data-testid="nav-group"
            className="font-accent text-xs uppercase tracking-[0.2em] text-dejure-purple hover:text-dejure-purple-dark transition-colors duration-300"
          >
            The Group
          </Link>
          {brandKey !== "group" &&
            links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className="font-accent text-xs uppercase tracking-[0.2em] text-dejure-ink/70 hover:text-dejure-purple transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta"
          className="md:hidden font-accent text-xs uppercase tracking-[0.2em] text-dejure-purple"
        >
          Contact
        </a>
      </div>
    </header>
  );
}
